import { normalizeDecimalInput } from './formatters';

export const stockFxSnapshotState = (record = {}) => ({
  brokerBaseCurrency: record.brokerBaseCurrency ?? '',
  brokerFXRate: record.brokerFXRate ?? '',
  fxRateToUSD: record.fxRateToUSD ?? '',
});

const normalizedSnapshotValue = (field, value) => {
  const text = String(value ?? '').trim();
  if (field === 'brokerBaseCurrency' || field === 'currency') return text.toUpperCase();
  if (field === 'brokerFXRate' || field === 'fxRateToUSD') {
    const decimal = normalizeDecimalInput(text);
    if (!/^\+?(?:\d+(?:\.\d*)?|\.\d+)$/.test(decimal)) return decimal;
    return decimal.replace(/^\+/, '').replace(/^\./, '0.').replace(/^0+(?=\d)/, '').replace(/(\.\d*?)0+$/, '$1').replace(/\.$/, '');
  }
  return text;
};

// Invalidate saved conversions only when the dependency actually changes.
// A manual rate entered during this edit is intentional, not a stale loaded value.
export const updateStockFxSnapshot = (current, field, value) => {
  const next = { ...current, [field]: value };
  if (field === 'fxRateToUSD') next._fxRateEntered = true;
  if (normalizedSnapshotValue(field, current[field]) === normalizedSnapshotValue(field, value)) return next;
  if (field === 'currency') {
    Object.assign(next, stockFxSnapshotState(), { _fxRateEntered: false });
  } else if (['timestamp', 'brokerBaseCurrency', 'brokerFXRate'].includes(field) && !current._fxRateEntered) {
    next.fxRateToUSD = '';
  }
  return next;
};

// Omit unchanged fields so automatic rates aren't relabeled as manual.
export const stockFxSnapshotChanges = (values, original = {}) => {
  const payload = {};
  Object.keys(stockFxSnapshotState()).forEach((field) => {
    const next = normalizedSnapshotValue(field, values[field]);
    if (next !== normalizedSnapshotValue(field, original[field]) || (field === 'fxRateToUSD' && values._fxRateEntered)) payload[field] = next;
  });
  return payload;
};
